// // Components
import general from './core/general';
import search from './components/search';
import gallery from './components/gallery';
const modules = [general, search, gallery];
modules.forEach(module => {
  module();
});

// const components = [
//   { el: '.c-gallery ', fileName: 'components/gallery' },
// ];
// const componentImport = async (el, fileName) => {
//   if (!document.querySelector(el)) return;
//   const module = await import(`./${fileName}`);
//   // Initialize module
//   if (typeof module === 'function') {
//     module();
//   } else if (typeof module === 'object' && typeof module.default === 'function') {
//     module.default();
//   }
// };
//
// components.forEach((component) => {
//   const { el, fileName } = component;
//   componentImport(el, fileName);
// });